import React from "react";
import backgraund from "../assets/profile_backgraund.jpg";
import AuthProvider from "../AuthContext";
import CurrentTrack from "./spotify/CurrentTrack";
import RecentlyPlayed from "./spotify/RecentlyPlayed";


const Hero = () => {
  
  return (
    <div className="flex justify-center items-center relative mt-5">
      <div className="md:w-[80%] w-[90%] border-4 border-black relative bg-white rounded-xl shadow-xl lg:p-8 h-[500px] lg:h-[400px] p-2 flex flex-col items-center">
        
        {/* Profil Fotoğrafı */}
        <div className="absolute z-20 mt-[-60px]">
          <img
            src="https://media.licdn.com/dms/image/v2/D4D03AQGOHH3B7cJ7tQ/profile-displayphoto-shrink_200_200/B4DZaheRfCHEAY-/0/1746465791268?e=1752105600&v=beta&t=Rxzk3nw7LN3CWq8JzmDJSnlYw9NKoiN3ymyP5QWVOxI"
            alt="Profil Fotoğrafı"
            className="md:w-60 w-40 md:h-60 h-40 rounded-full border-8 border-white shadow-lg object-cover"
          />
        </div>
        <div className="absolute w-full lg:h-[300px] h-[150px] rounded-xl">
          <AuthProvider>
            <div className="grid grid-cols-1 lg:grid-cols-5 w-full gap-4 p-10 w-full md:mt-[170px] mt-[130px]">
                <div className="w-20 m-auto z-20 flex lg:hidden items-center justify-center rounded-full bg-gray-900">
                    <svg className="w-[50px] h-[50px] text-[#B7B1F2] " viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12.01 2.019c-5.495 0-9.991 4.496-9.991 9.991 0 5.494 4.496 9.99 9.991 9.99 5.494 0 9.99-4.496 9.99-9.99 0-5.495-4.446-9.991-9.99-9.991zm4.595 14.436c-.199.299-.549.4-.85.201-2.349-1.45-5.296-1.75-8.793-.951-.348.102-.648-.148-.748-.449-.101-.35.149-.648.45-.749 3.795-.85 7.093-.499 9.69 1.1.35.149.4.548.251.848zm1.2-2.747c-.251.349-.7.499-1.051.249-2.697-1.646-6.792-2.148-9.939-1.148-.398.101-.85-.1-.949-.498-.101-.402.1-.852.499-.952 3.646-1.098 8.143-.548 11.239 1.351.3.149.45.648.201.998zm.099-2.799c-3.197-1.897-8.542-2.097-11.59-1.146a.938.938 0 0 1-1.148-.6.937.937 0 0 1 .599-1.151c3.547-1.049 9.392-.85 13.089 1.351.449.249.599.849.349 1.298-.25.35-.849.498-1.299.248z"/>
                    </svg>
                </div>
                <div className="col-span-2 z-20"><CurrentTrack /></div>
                <div className="col-span-1 col-start-3 w-full z-20 hidden lg:flex items-center justify-center rounded-full bg-gray-900">
                    <svg className="w-[50px] h-[50px] text-[#B7B1F2] " viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12.01 2.019c-5.495 0-9.991 4.496-9.991 9.991 0 5.494 4.496 9.99 9.991 9.99 5.494 0 9.99-4.496 9.99-9.99 0-5.495-4.446-9.991-9.99-9.991zm4.595 14.436c-.199.299-.549.4-.85.201-2.349-1.45-5.296-1.75-8.793-.951-.348.102-.648-.148-.748-.449-.101-.35.149-.648.45-.749 3.795-.85 7.093-.499 9.69 1.1.35.149.4.548.251.848zm1.2-2.747c-.251.349-.7.499-1.051.249-2.697-1.646-6.792-2.148-9.939-1.148-.398.101-.85-.1-.949-.498-.101-.402.1-.852.499-.952 3.646-1.098 8.143-.548 11.239 1.351.3.149.45.648.201.998zm.099-2.799c-3.197-1.897-8.542-2.097-11.59-1.146a.938.938 0 0 1-1.148-.6.937.937 0 0 1 .599-1.151c3.547-1.049 9.392-.85 13.089 1.351.449.249.599.849.349 1.298-.25.35-.849.498-1.299.248z"/>
                    </svg>
                </div>
                <div className="col-span-2 z-20"><RecentlyPlayed /></div>
                
            </div>
          </AuthProvider>
        </div>
        {/* Arka Plan */}
        <div className="relative w-full lg:h-[400px] h-[500px] overflow-hidden rounded-xl">
          
        <img
            src={backgraund}
            alt="backgraund"
            className="w-full h-full object-cover object-bottom"
          />
          
        </div>
        
      </div>
    </div>
  );
};

export default Hero;
